import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportData = ({
  fileName,
  type = 'excel',
  sheets = [],
}) => {
  if (type === 'excel') {
    exportToExcel(fileName, sheets);
  }

  if (type === 'pdf') {
    exportToPdf(fileName, sheets);
  }
};

const exportToExcel = (fileName, sheets) => {
  const workbook = XLSX.utils.book_new();

  sheets.forEach(({ name, data, mapper }) => {
    if (!data || !data.length) return;

    const rows = mapper ? data.map(mapper) : data;
    const worksheet = XLSX.utils.json_to_sheet(rows);

    XLSX.utils.book_append_sheet(workbook, worksheet, name);
  });

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

const exportToPdf = (fileName, sheets) => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'pt',
  });

  let firstPage = true;

  sheets.forEach(({ name, data, mapper, metadata }) => {
    if (!data || !data.length) return;

    const rows = mapper ? data.map(mapper) : data;
    if (!rows.length) return;

    const columns = Object.keys(rows[0]);

    if (!firstPage) {
      doc.addPage();
    }
    firstPage = false;

    doc.setFontSize(14);
    doc.text(name, 40, 40);

    let currentY = 40;

    if (metadata) {
      currentY += 18;
      doc.setFontSize(10);
      doc.text(metadata, 40, currentY);
    }

    autoTable(doc, {
      startY: currentY + 16,
      head: [columns],
      body: rows.map(row => columns.map(col => row[col])),
      styles: {
        fontSize: 8,
        cellPadding: 4,
        overflow: 'linebreak',
      },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: 20,
        fontStyle: 'bold',
      },
      margin: { left: 40, right: 40 },
    });
  });

  doc.save(`${fileName}.pdf`);
};
